module.exports = __webpack_public_path__ + "static/img/sec3-cont@t.becb27c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/design-samsung/sec3-cont@t.jpg
// module id = nD1T
// module chunks = 0